import { AppBar } from '@material-ui/core';
import { useGenericStyles } from 'common/genericStyles';
import React from 'react';

export const HorizontalAppBar: React.FC = (props) => {
  const classes = useGenericStyles();
  return (
    <AppBar className={classes.appBar} elevation={0} color="transparent" position="static">
      {props.children}
    </AppBar>
  );
};
